import Reflux from 'reflux';

const InvitationDetail = Reflux.createActions([
  'read',
  'nextInvitations',
  'prevInvitations',
  'countInvitations'
]);

export default InvitationDetail;



// WEBPACK FOOTER //
// ./src/js/actions/InvitationDetail.js